import React from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { MdErrorOutline } from "react-icons/md";
import "./input.css";

const Input = (props) => {
  const {
    label,
    name,
    placeholder,
    value,
    errors,
    touched,
    handleChange,
    handleKeyDown,
    disabled,
    type = "text",
    handleOnBlur,
    style,
    isPassword,
    rows,
    inputMode,
    maxLength,
  } = props;

  const hasError = Boolean(touched?.[name] && errors?.[name]);
  const errorMessage = hasError ? String(errors[name]) : "";

  const [show, setShow] = React.useState(false);

  const isTextarea = type === "textarea";
  const resolvedType = isPassword ? (show ? "text" : "password") : type;

  return (
    <div className="input-wrapper" style={style}>
      {label && <label className="input-label">{label.toUpperCase()}</label>}

      <div
        className={`input-field-container ${hasError ? "input-field-container--error" : ""}`}
      >
        {isTextarea ? (
          <textarea
            className="input-field input-field--textarea"
            name={name}
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onBlur={handleOnBlur}
            placeholder={placeholder}
            disabled={disabled}
            rows={rows || 3}
            maxLength={maxLength}
          />
        ) : (
          <input
            className="input-field"
            name={name}
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onBlur={handleOnBlur}
            placeholder={placeholder}
            disabled={disabled}
            type={resolvedType}
            inputMode={inputMode}
            maxLength={maxLength}
          />
        )}

        {isPassword && (
          <button
            type="button"
            className="input-eye-icon"
            onClick={() => setShow((prev) => !prev)}
            tabIndex={-1}
          >
            {show ? <FiEyeOff size={16} /> : <FiEye size={16} />}
          </button>
        )}
      </div>

      {hasError && (
        <p className="input-error-text">
          <MdErrorOutline size={16} />
          <span>{errorMessage}</span>
        </p>
      )}
    </div>
  );
};

export default Input;
